export const VIEW = Object.freeze({
  DETAIL: "detail",
  FORM: "form",
});

export const SUCCESS_MESSAGE_DURATION_MS = 5000;

export const FIELD_DEFINITIONS = Object.freeze([
  {
    name: "bradenSensoryPerception",
    label: "Sensory Perception",
    desc: "Ability to respond meaningfully to pressure related discomfort",
  },
  {
    name: "bradenMoisture",
    label: "Moisture",
    desc: "Degree to which skin is exposed to moisture",
  },
  {
    name: "bradenActivity",
    label: "Activity",
    desc: "Degree of physical Activity",
  },
  {
    name: "bradenMobility",
    label: "Mobility",
    desc: "Ability change and control body position",
  },
  {
    name: "bradenNutrition",
    label: "Nutrition",
    desc: "Usual food intake pattern(NPO-Nothing by mouth, IV-Intrvenously, TPN-Total Parental Nutrition)",
  },
  {
    name: "bradenFrictionShear",
    label: "Friction & Shear",
    desc: "-",
  },
]);

export const INITIAL_FORM_DATA = FIELD_DEFINITIONS.reduce((acc, field) => {
  acc[field.name] = null;
  return acc;
}, {});
